 function FieldError({ error }) {
  return (
    <div className="p-2 mt-2 text-xs text-red-500/70 rounded-md bg-red-500/15 border border-red-500/10">
      {error}
    </div>
  )}
  export default FieldError;

